import { withTranslation } from '@application/i18n/with_translation';
import { tokens } from '@cellula/react-theme-patient';
import {
	createCompletedInformationGatheringState,
	getCompletedInformationGathering,
	releaseInformationGatheringState,
} from '@feature/information-gathering/information-gathering-navigation';
import { useResolveController, useService } from '@visiba/instantiation';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { ScreenRedRobinSessionIframeController } from './screen_session_iframe.controller';

const StyledIframe = styled.iframe`
	width: 600px;
	height: 840px;

	max-height: calc(100dvh - ${tokens.size.x7}); // Total height with outlet header area subtracted
	min-width: 320px;
	max-width: 100%;
	border: 0;
	border-top: 1px solid ${tokens.color.border.default};

	${tokens.breakpointQuery.small} {
		min-height: 650px;
		max-height: calc(
			100vh - var(--header-height) - ${tokens.size.x6} - ${tokens.size.x7} - ${tokens.size.x1}
		); // Height subtracted with Page header, Margin and Outlet header + 1 for some space
	}
`;

interface ScreenRedRobinSessionIframeProps {
	handleSessionSubmitted(): void;
}
export function ScreenRedRobinSessionIframe({ handleSessionSubmitted }: ScreenRedRobinSessionIframeProps) {
	const controller = useResolveController(ScreenRedRobinSessionIframeController);
	const location = useLocation();
	const completedInformationGathering = getCompletedInformationGathering(location.state);

	function handlePostEventFromIframe(messageEvent: MessageEvent) {
		const { event, data } = messageEvent.data;
		if (data === undefined) return;

		if (event === 'RedRobinSessionCompleted') {
			try {
				const { url } = JSON.parse(data);
				if (url != null && url !== '') {
					const nextState =
						completedInformationGathering === null
							? undefined
							: createCompletedInformationGatheringState(completedInformationGathering);
					controller.navigateToExitUrl(url, nextState);
					releaseInformationGatheringState(location.state);
				}
				// biome-ignore lint/correctness/noUnusedVariables: suppressed due to migration - should be fixed
			} catch (error) {
				// noop
			}
		}

		if (event === 'RedRobinSessionSubmitted') {
			handleSessionSubmitted();
		}
	}

	// biome-ignore lint/correctness/useExhaustiveDependencies: suppressed due to migration - should be fixed
	useEffect(function whenMounted() {
		window.addEventListener('message', handlePostEventFromIframe, false);

		return () => {
			window.removeEventListener('message', handlePostEventFromIframe, false);
		};
	}, []);

	if (!controller.viewData.value.sessionUrl) {
		return null;
	}

	return <StyledIframe title={withTranslation('View.RedRobin.Title')} src={controller.viewData.value.sessionUrl} />;
}
